import TutorAssignmentLoader from './parts/Loaders/TutorAssignmentLoader';
import TutorAssignmentTable from './parts/TutorAssignmentTable';

function TutorAssignment() {
  return (
    <TutorAssignmentLoader>
      <TutorAssignmentTable />
    </TutorAssignmentLoader>
  );
}

export default TutorAssignment;
